<template>
  <v-card flat class="settings-card">
    <v-container>
      <v-card-title class="settings-header-text">Customer Settings</v-card-title>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-select
                label="Required New Customer Fields"
                placeholder="Required New Customer Fields"
                :value="requiredNewCustomerFieldsValue"
                @input="updateConfig('requiredNewCustomerFields', $event)"
                :items="newCustomerFields"
                item-text="label"
                item-value="value"
                multiple
                chips
                class="py-1"
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="mt-6 mb-10 float-right">
            <v-btn
              color="primary"
              @click="onSave"
              class="mb-2 px-8"
              :disabled="!(settings ? settings.isDirty : false)"
              >Save</v-btn
            >
          </v-row>
        </v-form>
      </v-container>
    </v-container>
  </v-card>
</template>

<script>
import { mask } from "vue-the-mask";
import { NEW_CUSTOMER_FIELDS } from "../../globalVars";

export default {
  name: "CustomerSettings",
  components: {},
  directives: {
    mask
  },
  data: function() {
    return {
      formValid: true,
      requiredNewCustomerFieldsValue: []
    };
  },
  async created() {
    await this.$store.dispatch("entities/settings/hydrate", 0);
    const settings = this.$store.getters["entities/settings/query"]().first();
    this.requiredNewCustomerFieldsValue =
      settings &&
      settings.customerSettings &&
      settings.customerSettings.requiredNewCustomerFields
        ? settings.customerSettings.requiredNewCustomerFields
        : NEW_CUSTOMER_FIELDS.map(obj => obj.value);
  },
  computed: {
    account() {
      return this.$store.getters["entities/accounts/query"]()
        .withAllRecursive(1)
        .first();
    },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    newCustomerFields() {
      return NEW_CUSTOMER_FIELDS;
    }
  },
  methods: {
    updateConfig(name, value) {
      let vueThis = this;
      let data = {
        isDirty: true,
        customerSettings:
          this.settings && this.settings.customerSettings
            ? this.settings.customerSettings
            : {}
      };
      if (name == "requiredNewCustomerFields") {
        data.customerSettings.requiredNewCustomerFields = value;
      }
      this.$store.dispatch("entities/settings/update", {
        where: vueThis.settings.id,
        data: data
      });
    },
    onSave(evt) {
      evt.preventDefault();
      let vueThis = this;
      this.$store.dispatch(
        "entities/settings/updateSettings",
        vueThis.settings
      );
    }
  },
  watch: {}
};
</script>

<style scoped lang="stylus">
div.spacer {
  width: 3rem;
}
</style>
